import React from 'react'
import { Font } from '../../../../types/Font'
import cx from 'classnames'
import styles from './DeleteFontModal.module.css'
import Text from '../../../../components/Text'
import Button from '../../../../components/Button'
import { useTranslation } from 'react-i18next'
import { useDeleteData } from '../../../../hooks/useDeleteData'
import { ApiRoutes } from '../../../../services/ApiService'
import { closeModal } from '../../../../services/ModalService'
import { showToast } from '../../../../services/ToastService'

const DeleteFontModal: React.FC<{ font: Font; onSubmit: () => void }> = ({
    font,
    onSubmit,
}) => {
    const { t } = useTranslation(['settings'])
    const { submit } = useDeleteData(ApiRoutes.FONTS, font.id)

    const handleSubmit = () => {
        submit().then((res) => {
            if (res.status === 204) {
                closeModal()
                showToast(t('fonts.delete_modal.success'))
            } else {
                showToast(t('fonts.delete_modal.error'), 'error')
            }
            onSubmit()
        })
    }

    const handleAbort = () => {
        closeModal()
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>
                {t('fonts.delete_modal.sub_heading', { font_name: font.name })}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('fonts.delete_modal.delete')}
                fn={() => handleSubmit()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => handleAbort()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
        </div>
    )
}

export default DeleteFontModal
